'use client';

import { useState } from 'react';
import { Box } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../components/typography';
import {
  TraceCollapsible,
  TraceCollapsibleContent,
  TraceCollapsibleTrigger,
  TraceLine,
} from './trace';

type FailedToolCallRowProps = {
  title: string;
  explanation: string;
};

export function FailedToolCallRow({
  title,
  explanation,
}: FailedToolCallRowProps) {
  const [open, setOpen] = useState(false);

  return (
    <TraceCollapsible
      open={open}
      onOpenChange={({ open: nextOpen }) => setOpen(nextOpen)}
    >
      <TraceCollapsibleTrigger>
        <TraceLine title={title} canExpand isExpanded={open} />
      </TraceCollapsibleTrigger>
      <TraceCollapsibleContent open={open}>
        <Box pt={1} pl={3}>
          <MetaDefault color="fg.muted">{explanation}</MetaDefault>
        </Box>
      </TraceCollapsibleContent>
    </TraceCollapsible>
  );
}
